<template>
  <v-data-table
    item-key="id"
    disableSort
    :items-per-page="-1"
    :headers="headers"
    :items="items"
    hide-default-footer
    class="mt-3 elevation-1"
  >
    <template v-slot:[`item.index`]="{ item }">
      {{ item | ordinalNumber(items) }}
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <CardStudentName :student="item.student" link />
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      {{ $_get(item, 'student.dob') | ddmmyyyy }}
    </template>
    <template v-slot:[`item.class`]="{ item }">
      {{ $_get(item, 'class.title', '--') }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <div class="d-flex flex-column">
        <div>
          <v-chip
            small
            style="margin: 0"
            class="white--text"
            :color="item.status | boardingClassSessionAttendanceStatusColor"
            label
          >
            {{ item.status | boardingClassSessionAttendanceStatusText }}
          </v-chip>
        </div>
        <div class="mt-2">
          <v-chip
            small
            style="margin: 0"
            class="white--text"
            v-if="item.subStatus && item.subStatus !== 'none'"
            :color="item.subStatus | boardingClassSessionAttendanceSubStatusColor"
            label
          >
            {{ item.subStatus | boardingClassSessionAttendanceSubStatusText }}
          </v-chip>
        </div>
      </div>
    </template>
  </v-data-table>
</template>
<script>
import { mapGetters } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
const headers = [
  { text: 'STT', value: 'index' },
  { text: 'Học sinh', value: 'name' },
  { text: 'Ngày sinh', value: 'dob' },
  { text: 'Lớp', value: 'class' },
  { text: 'Trạng thái', align: 'center', value: 'status' },
]
export default {
  components: { CardStudentName },
  data: () => ({ headers }),
  computed: {
    ...mapGetters({ items: 'boardingClassSessionAttendance/items' }),
  },
}
</script>
